import Request from './request';
import snackbar from '@/plugins/snackbar';
import i18n from '@/i18n';
import store from "../store";

async function fetch(data) {
    return Request('get', "api/stock-takes", data);
}

async function fetchOne(id, data) {
    return Request('get', "api/stock-takes/" + id, data);
}

async function addPreview(data) {
    return Request('patch', "api/stock-takes/add-view" , data);
}

async function addStockTake(data) {
    return Request('patch', "api/stock-takes/add" , data);
}

async function cancel(id) {
    return Request('get', "api/stock-takes/cancel/" + id);
}

async function positionStockTake(data) {
    return Request('post', "api/stock-takes/position-stock-take" , data)
}

async function stockTake(data) {
    return Request('patch', "api/stock-takes/stock-take" , data)
}

async function exports(id){ //导出报表
    store.dispatch("fullscreenLoading");
      const response = await Request('get',"api/stock-takes/detail-export/" + id)
      if(response.data && response.data.status.isOK()){
          snackbar.info(i18n.t("Export.recordedHint"))
      }
      store.dispatch("fullscreenLoadingStop")
      return response
}

 async function commonTemplatexport(data){ //导出普通盘点下载
    store.dispatch("fullscreenLoading");
      const response = await Request('get',"api/stock-takes/common-template-export",data)
      if(response.data && response.data.status.isOK()){
          snackbar.info(i18n.t("Export.recordedHint"))
      }
      store.dispatch("fullscreenLoadingStop")
      return response
}
  
async function batchTemplateExport(id, code) { //导出批次盘点下载
    store.dispatch("fullscreenLoading");
      const response = await Request('get',"api/stock-takes/batch-template-export?stock_id=" + id +"&category_code=" + code)
      if(response.data && response.data.status.isOK()){
          snackbar.info(i18n.t("Export.recordedHint"))
      }
      store.dispatch("fullscreenLoadingStop")
      return response
}

async function positionTemplateExport(id, code) { //导出库位批次盘点下载
    store.dispatch("fullscreenLoading");
      const response = await Request('get',"api/stock-takes/position-template-export?stock_id=" + id +"&category_code=" + code)
      if(response.data && response.data.status.isOK()){
          snackbar.info(i18n.t("Export.recordedHint"))
      }
      store.dispatch("fullscreenLoadingStop")
      return response
}

async function importCommonTemplate(file,id) {      //普通模板导入
    var data = new FormData()
    data.append('excel', file)
    data.append('stock_id', id)
    return Request('post', "api/stock-takes/import-common-save", data)
}

async function importBatchTemplate(file,id) {      //批次模板导入
    var data = new FormData()
    data.append('excel', file)
    data.append('stock_id', id)
    return Request('post', "api/stock-takes/importBatchSave", data)
}

async function importPositionTemplate(file,id) {      //库位批次模板导入
    var data = new FormData()
    data.append('excel', file)
    data.append('stock_id', id)
    return Request('post', "api/stock-takes/importPositionSave", data)
}

async function editStockTake(data) {
    return Request('post', "api/stock-takes/edit",data)
}

export default {
    fetch,
    fetchOne,
    addPreview,
    addStockTake,
    cancel,
    positionStockTake,
    stockTake,
    exports,
    commonTemplatexport,
    batchTemplateExport,
    positionTemplateExport,
    importCommonTemplate,
    importBatchTemplate,
    importPositionTemplate,
    editStockTake,
};